import './WhatsAppButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/+60124825199', '_blank');
  };

  return (
    <button
      className="whatsapp-float-btn"
      onClick={handleWhatsAppClick}
      aria-label="Contact us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
    </button>
  );
};

export default WhatsAppButton;